// src/base/Root/context.ts
import { createContext } from "react";
var RootContext = createContext({
  iconSpritePath: void 0,
  brandSpritePath: void 0,
  brand: void 0,
  brandSectionBgWhitePath: void 0,
  brandSectionBgPrimaryPath: void 0
});
export { RootContext };